import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    value: {},
  },
  reducers: {
    updateUser: (state, newValue) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes.
      // Also, no return statement is required from these functions.
      state.value = newValue.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { updateUser } = userSlice.actions

export const selectUser = (state) => state.user.value

export default userSlice.reducer